import { KleverSpinner, LoginContainer } from './styles';

export function Spinner() {
  return (
    <LoginContainer>
      <KleverSpinner />
    </LoginContainer>
  );
}
